import React, { useEffect, useState } from "react";
import "./styles.css";
import Layout from "../Layout/Content";
import Logo from "../../../image/Logo.png";
import RegisterImg from "../../../image/register-img.png";
import { useLocation, useNavigate } from "react-router-dom";
import { ethers } from "ethers";
import { useAuth } from "../../context/auth";
import { toast } from "react-toastify";
import axios from "axios";
import Typewriter from "typewriter-effect";
import { motion } from "motion/react";
import {
  contractABI,
  contractAddress,
  DeodAbi,
  DeodAddress,
  nefiStaking,
  nefiStakingABI,
  StakeAbi,
  StakeAddress,
  StakeAddressTwo,
  StakeV2Balance,
} from "../Abi/Content";
import Marquee from "react-fast-marquee";
// NEW

const Content = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [regUsers, setregUsers] = useState(false);
  const [auth, setAuth] = useAuth();
  const [refferal, setRefferal] = useState("");
  const location = useLocation();
  const targetDate = new Date('2025-05-31T12:30:00').getTime();
  const [timeLeft, setTimeLeft] = useState(targetDate - new Date().getTime());

  const [totalDeodStack, setTotaldeodStack] = useState();
  const handleIsRegisterApi = async (address) => {
    try {
      const resp = await axios.post(`/users/login`, {
        accountAddress: address,
      });
      if (resp.status === 200) {
        toast.success("Account already Registered , Please Login !")
      }
    } catch (error) {
      if (error.response.status === 400) {
        var err_400 = error?.response?.data?.message;
        toast.error(err_400);
      } else if (error.response.status === 401) {
        const err_401 = error?.response?.data?.message;
        toast.error(err_401);
      } else if (error.response.status === 404) {
        const err_404 = error?.response?.data?.message;
        const isAdmin = ["0xDD8703720aB03bf0738037a2d4F84b3bECf353Fb"];
        var role = isAdmin.indexOf(address) !== -1 ? 1 : 0;
        setAuth({
          ...auth,
          user: {
            address: address,
            referralAddress: refferal,
            role: role,
          },
        });
        sessionStorage.setItem(
          "auth",
          JSON.stringify({
            user: {
              address: address,
              referralAddress: refferal,
              role: role,
            },
          })
        );
        navigate("/register");
      } else if (error.response.status === 500) {
        const err_500 = error?.response?.data?.message;
        toast.error(err_500);
      } else {
        console.log("Error in Register", error);
        toast.error("something went wrong");
      }
    }
  };
  const handleIsRegisterApiPro = async (address) => {
    try {
      const resp = await axios.post(`/nefi-pro-users/login`, {
        accountAddress: address,
      });
      if (resp.status === 200) {
        toast.success("Account already Registered , Please Login !")
      }
    } catch (error) {
      if (error.response.status === 400) {
        var err_400 = error?.response?.data?.message;
        toast.error(err_400);
      } else if (error.response.status === 401) {
        const err_401 = error?.response?.data?.message;
        toast.error(err_401);
      } else if (error.response.status === 404) {
        const err_404 = error?.response?.data?.message;
        const isAdmin = ["0xDD8703720aB03bf0738037a2d4F84b3bECf353Fb"];
        var role = isAdmin.indexOf(address) !== -1 ? 1 : 0;
        setAuth({
          ...auth,
          user: {
            address: address,
            referralAddress: refferal,
            role: role,
          },
        });
        sessionStorage.setItem(
          "auth",
          JSON.stringify({
            user: {
              address: address,
              referralAddress: refferal,
              role: role,
            },
          })
        );
        navigate("/register");
      } else if (error.response.status === 500) {
        const err_500 = error?.response?.data?.message;
        toast.error(err_500);
      } else {
        console.log("Error in Register", error);
        toast.error("something went wrong");
      }
    }
  };
  // const networkId = 137  //mainnet
  const networkId = 56  //testnet
         //    /*Switch to mainnet*/  const networkData = [
         //         {
         //             chainId: ethers.utils.hexlify(networkId),
         //             rpcUrls: ["https://polygon-rpc.com"],

         //             chainName: "Polygon Mainnet",
         //             nativeCurrency: {
         //                 name: "MATIC",
         //                 symbol: "MATIC", // 2-6 characters long
         //                 decimals: 18,
         //             },
         //             blockExplorerUrls: ["https://polygonscan.com/"],
         //         },
         //     ]
             /*Switch to Testnet*/  const networkData = [
    {
      chainId: networkId,
      rpcUrls: ["https://bsc-dataseed.binance.org/"],

      chainName: "BNB Smart Chain",
      nativeCurrency: {
        name: "BNB",
        symbol: "BNB", // 2-6 characters long
        decimals: 18,
      },
      blockExplorerUrls: ["https:/https://bscscan.com/"],
    },
  ]
  const switchNetworks = async () => {

    try {
      await window.ethereum.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: ethers.utils.hexlify(networkId) }],
      });
    } catch (switchError) {
      // This error code indicates that the chain has not been added to MetaMask.
      if (switchError.code === 4902) {
        try {
          await window.ethereum.request({
            method: 'wallet_addEthereumChain',
            params: networkData
          });
        } catch (addError) {
          // handle "add" error
        }
      }
      // handle other "switch" errors
    }

  }
  const handleIsregister = async () => {
    // e.preventDefault();
    setLoading(true);
    try {
      let provider;
      if (window.ethereum) {
        provider = window.ethereum;
      } else if (window.web3) {
        provider = window.web3.currentProvider;
      } else {
        window.alert("No ethereum browser !checkout metamask");
      }
      if (provider) {
        if (provider !== window.ethereum) {
          console.error(
            "Not window.ethereum.Do you have multiple wallets installed"
          );
        }
        await provider.request({
          method: "eth_requestAccounts",
        });
      }
      const providera = new ethers.providers.Web3Provider(window.ethereum)
      const signer1 = providera.getSigner();
      const account = await signer1.getAddress()
      const network = await providera.getNetwork()
      console.log(network)
      if (network.chainId !== networkId) {
        await switchNetworks()
      }
      const newProvider = new ethers.providers.Web3Provider(window?.ethereum);
      const signer = newProvider.getSigner();
      const message = [
        "Welcome to NexDefi !",
        "Please sign this message to verify your identity.",
        "Please sign in!",
      ].join("\n\n");
      
      await signer.signMessage(message);
      const currentaccount = await signer.getAddress();
      const address = currentaccount.toLowerCase();
      const contract = new ethers.Contract(nefiStaking, nefiStakingABI, signer)
      const referral = await contract.referral(address)
      const defaultRefferalAddress = "0x0605E6A1eead9aC175879a5757Eba687DF5ee6a4".toLowerCase();
      if (defaultRefferalAddress == address) {
        sessionStorage.setItem('isAuthenticated', 'true');
        navigate('/dashboard')
        setLoading(false);
        return
      }
      if (referral !== `0x0000000000000000000000000000000000000000`) {
        toast.error("User Already Registered ! Please Login")
      } else {
        // sessionStorage.setItem('isAuthenticated', 'true');
        navigate('/register')
      }
    } catch (error) {
      console.log("wallet loagin Error", error);
    }
    setLoading(false);
  };
  // const handleIsregister = async () => {
  //   alert('Server under maintenence , Please try again later !')
  // }
  // const handleLogin = async () => {

  // }
  const handleIsConnectApi = async (address) => {
    try {
      const resp = await axios.post(`/users/login`, {
        accountAddress: address,
      });
      if (resp.status === 200) {
        if (resp?.data?.status === true) {
          const message = resp?.data?.message;
          const { accountAddress, sponserAddress, dateOfRegistration, userId } =
            resp?.data?.data;
          if (message === "Login successful") {
            const isAdmin = [
              // "0x7f967ec284ce3e3e3503c19db74dc697aea4c0f2",
              "0xDD8703720aB03bf0738037a2d4F84b3bECf353Fb",
            ];
            var role = isAdmin.indexOf(address) !== -1 ? 1 : 0;
            setAuth({
              ...auth,
              user: {
                userId,
                address: accountAddress,
                referralAddress: sponserAddress,
                role: role,
                token: resp?.data?.token,
                dateOfRegistration,
              },
            });
            sessionStorage.setItem(
              "auth",
              JSON.stringify({
                user: {
                  userId,
                  address: accountAddress,
                  referralAddress: sponserAddress,
                  role: role,
                  token: resp?.data?.data?.token,
                  dateOfRegistration,
                },
              })
            );
            sessionStorage.setItem('isAuthenticated', 'true');
            sessionStorage.setItem("myToggled", 0);
            sessionStorage.setItem('token', resp?.data?.data?.token,)

            axios.defaults.headers.common[
              "Authorization"
            ] = `Bearer ${resp?.data?.token}`;
            let data = sessionStorage.getItem("auth");
            data = JSON.parse(data);
            const admin = data?.user?.role;
            if (admin === 1) {
              navigate("/admin-dashboard");
            } else {
              navigate("/dashboard");
            }
          }
        }
      } else {
        toast.error("Error", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      if (error.response.status === 400) {
        var err_400 = error?.response?.data?.message;
        toast.error(err_400);
      } else if (error.response.status === 401) {
        const err_401 = error?.response?.data?.message;
        toast.error(err_401);
      } else if (error.response.status === 404) {
        const err_404 = error?.response?.data?.message;
        if (err_404 == "Invalid Account Address!") {
          toast.error('Invalid Account Address ,Please Register !');

        } else {
          toast.error(err_404);
        }
      } else if (error.response.status === 500) {
        const err_500 = error?.response?.data?.message;
        toast.error(err_500);
      } else {
        console.log("Error in Register", error);
        toast.error("something went wrong");
      }
    }
  };
  const handleIsConnectApiPro = async (address) => {

    try {
      const resp = await axios.post(`/users/login`, {
        accountAddress: address,
      });
      if (resp.status === 200) {
        if (resp?.data?.status === true) {
          const message = resp?.data?.message;
          const { accountAddress, sponserAddress, dateOfRegistration, userId } =
            resp?.data?.data;
          if (message === "Login successful") {
            const isAdmin = [
              // "0x7f967ec284ce3e3e3503c19db74dc697aea4c0f2",
              "0xDD8703720aB03bf0738037a2d4F84b3bECf353Fb",
            ];
            var role = isAdmin.indexOf(address) !== -1 ? 1 : 0;
            setAuth({
              ...auth,
              user: {
                userId,
                address: accountAddress,
                referralAddress: sponserAddress,
                role: role,
                token2: resp?.data?.token,
                dateOfRegistration,
              },
            });
            sessionStorage.setItem(
              "auth",
              JSON.stringify({
                user: {
                  userId,
                  address: accountAddress,
                  referralAddress: sponserAddress,
                  role: role,
                  token2: resp?.data?.data?.token,
                  dateOfRegistration,
                },
              })
            );
            sessionStorage.setItem('isAuthenticated', 'true');
            sessionStorage.setItem("myToggled2", 0);
            sessionStorage.setItem('token', resp?.data?.data?.token,)
            axios.defaults.headers.common[
              "Authorization"
            ] = `Bearer ${resp?.data?.token}`;
            let data = sessionStorage.getItem("auth");
            data = JSON.parse(data);
            const admin = data?.user?.role;
            if (admin === 1) {
              navigate("/admin-dashboard");
            } else {
              try {
                const resp2 = await axios.post(`/nefi-pro-users/login`, {
                  accountAddress: address,
                });
                if (resp2.status === 200) {
                  sessionStorage.setItem('token2', resp2?.data?.data?.token,)
                }
              } catch (error) {

              }

              navigate("/dashboard");
            }
          }
        }
      } else {
        toast.error("Error", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      if (error.response.status === 400) {
        var err_400 = error?.response?.data?.message;
        toast.error(err_400);
      } else if (error.response.status === 401) {
        const err_401 = error?.response?.data?.message;
        toast.error(err_401);
      } else if (error.response.status === 404) {
        const err_404 = error?.response?.data?.message;
        if (err_404 == "Invalid Account Address!") {
          toast.error('Invalid Account Address ,Please Register !');

        } else {
          try {
            const resp = await axios.post(`/nefi-pro-users/login`, {
              accountAddress: address,
            });
            if (resp.status === 200) {
              if (resp?.data?.status === true) {
                const message = resp?.data?.message;
                const { accountAddress, sponserAddress, dateOfRegistration, userId } =
                  resp?.data?.data;
                if (message === "Login successful") {
                  const isAdmin = [
                    // "0x7f967ec284ce3e3e3503c19db74dc697aea4c0f2",
                    "0xDD8703720aB03bf0738037a2d4F84b3bECf353Fb",
                  ];
                  var role = isAdmin.indexOf(address) !== -1 ? 1 : 0;
                  setAuth({
                    ...auth,
                    user: {
                      userId,
                      address: accountAddress,
                      referralAddress: sponserAddress,
                      role: role,
                      token2: resp?.data?.token,
                      dateOfRegistration,
                    },
                  });
                  sessionStorage.setItem(
                    "auth",
                    JSON.stringify({
                      user: {
                        userId,
                        address: accountAddress,
                        referralAddress: sponserAddress,
                        role: role,
                        token2: resp?.data?.data?.token,
                        dateOfRegistration,
                      },
                    })
                  );
                  sessionStorage.setItem('isAuthenticated', 'true');
                  sessionStorage.setItem("myToggled", 0);
                  sessionStorage.setItem('token2', resp?.data?.data?.token,)
                  axios.defaults.headers.common[
                    "Authorization"
                  ] = `Bearer ${resp?.data?.token}`;
                  let data = sessionStorage.getItem("auth");
                  data = JSON.parse(data);
                  const admin = data?.user?.role;
                  if (admin === 1) {
                    navigate("/admin-dashboard");
                  } else {
                    navigate("/admin");
                  }
                }
              }
            } else {
              toast.error("Error", {
                position: toast.POSITION.TOP_RIGHT,
              });
            }
          } catch (error) {
            if (error.response.status === 400) {
              var err_400 = error?.response?.data?.message;
              toast.error(err_400);
            } else if (error.response.status === 401) {
              const err_401 = error?.response?.data?.message;
              toast.error(err_401);
            } else if (error.response.status === 404) {
              const err_404 = error?.response?.data?.message;
              if (err_404 == "Invalid Account Address!") {
                toast.error('Invalid Account Address ,Please Register !');

              } else {
                toast.error(err_404);
              }
            } else if (error.response.status === 500) {
              const err_500 = error?.response?.data?.message;
              toast.error(err_500);
            } else {
              console.log("Error in Register", error);
              toast.error("something went wrong");
            }
          }
        }
      } else if (error.response.status === 500) {
        const err_500 = error?.response?.data?.message;
        toast.error(err_500);
      } else {
        console.log("Error in Register", error);
        toast.error("something went wrong");
      }
    }
  };
  const handleLogin = async (e) => {
    // e.preventDefault();
    setLoading(true);
    try {
      let provider;
      if (window.ethereum) {
        provider = window.ethereum;
      } else if (window.web3) {
        provider = window.web3.currentProvider;
      } else {
        window.alert("No ethereum browser !checkout metamask");
      }
      if (provider) {
        if (provider !== window.ethereum) {
          console.error(
            "Not window.ethereum.Do you have multiple wallets installed"
          );
        }
        await provider.request({
          method: "eth_requestAccounts",
        });
      }
      debugger
      const providera = new ethers.providers.Web3Provider(window.ethereum)
      const signer1 = providera.getSigner();
      const account = await signer1.getAddress()
      const network = await providera.getNetwork()
      console.log(network)
      if (network.chainId !== networkId) {
        await switchNetworks()
      }
      const newProvider = new ethers.providers.Web3Provider(window?.ethereum);
      const signer = newProvider.getSigner();
      const message = [
        "Welcome to the NexDefi !",
        "Please sign this message to verify your identity.",
        "Please sign in!",
      ].join("\n\n");
      await signer.signMessage(message);
      const currentaccount = await signer.getAddress();
      const address = currentaccount.toLowerCase();
      // setAddress(address);
      const defaultRefferalAddress = ("0x0605E6A1eead9aC175879a5757Eba687DF5ee6a4").toLowerCase();
      if (defaultRefferalAddress == address) {
        sessionStorage.setItem('isAuthenticated', 'true');
        navigate('/dashboard')
        setLoading(false);
        return
      }
      const contract = new ethers.Contract(nefiStaking, nefiStakingABI, signer)
      const referral = await contract.referral(address)
      if (referral == `0x0000000000000000000000000000000000000000`) {
        toast.error("User Not Registered ! Please Register first ")
      } else {
        sessionStorage.setItem('isAuthenticated', 'true');
        navigate('/dashboard')
      }

    } catch (error) {
      console.log("wallet loagin Error", error);
    }
    setLoading(false);
  };
  const getRegisteredUsers = async () => {

    const resp = await axios('/users/total')
    console.log(resp.data.totalUser)
    setregUsers(resp.data.totalUser)
  }
  // State to hold remaining time in seconds
  const formatTimeLeft = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const days = Math.floor(hours / 24)
    const remainingHours = hours % 24
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return {
      days,
      remainingHours,
      minutes,
      seconds,
    };
  };
  // useEffect to update the countdown
  const { days, remainingHours, minutes, seconds } = formatTimeLeft(timeLeft);
  useEffect(() => {
    const intervalId = setInterval(() => {
      const currentTime = new Date().getTime();
      const difference = targetDate - currentTime;

      // Stop the countdown when time runs out
      if (difference <= 0) {
        clearInterval(intervalId);
        setTimeLeft(0);
      } else {
        setTimeLeft(difference);
      }
    }, 1000);

    // Cleanup interval when component unmounts
    return () => clearInterval(intervalId);
  }, [targetDate]);
  useEffect(() => {
    if (location?.search !== "") {
      var dataSplit = location?.search.split("/");
      dataSplit = dataSplit[0].split("?")[1];
      setRefferal(dataSplit);
    }
  }, [location?.pathname]);

  useEffect(() => {
    const jsonRpcUrl = "https://polygon-rpc.com";
    const provider = new ethers.providers.JsonRpcProvider(jsonRpcUrl);

    const handleGetTotalDeodStack = async () => {
      try {
        const DeodContract = new ethers.Contract(
          DeodAddress,
          DeodAbi,
          provider
        );
        let totalstackBalance = await DeodContract.balanceOf(StakeV2Balance);
        totalstackBalance = parseFloat(totalstackBalance) / 10 ** 18;
        totalstackBalance = totalstackBalance.toFixed(2);
        setTotaldeodStack(totalstackBalance);
      } catch (error) {
        console.log("totalstack error", error);
      }
    };

    handleGetTotalDeodStack();
    // getRegisteredUsers()
  }, []);
  // console.log("totaldeodStack", totalDeodStack);
  useEffect(() => {
    // Extracting the query parameters
    const queryParams = new URLSearchParams(location.search);

    // Getting the value of a specific parameter (e.g., 'id')
    const id = queryParams.get('referral');

    if (id) {
      // Storing the parameter value in sessionStorage
      setAuth({
        ...auth,
        user: null,
      });
      sessionStorage.clear();
      sessionStorage.setItem('referral', id);
      setRefferal(id)
    }
  }, [location.search]);
  return (
    <Layout>
      <div className="bg-dark text-white min-vh-100">
      {/* Hero Section */}
      <section className="text-center py-5 bg-black">
         <img
                  className="img-fluid  mb-3"
                  style={{
                    width: "200px",
                  }}
                  src={`/assets/symbol-nefi.png`}
                  alt=""
                />
        <h1 className="display-4 fw-bold">Stake NEFI<span style={{color:'#00ffc896'}}>AI</span> Tokens</h1>
        <p className="lead text-secondary">
          Earn rewards, support the network, and grow with NEFI AI
        </p>
        <div className="d-flex justify-content-center gap-3 mt-4">
          <button className="btn connect-btn btn-lg" onClick={handleLogin}>Stake Now</button>
          <button className="btn btn-outline-light rounded-pill btn-lg px-4" onClick={handleIsregister}>Register</button>
        </div>
        {/* <div className="mt-5 px-4 py-2 d-flex align-items-center justify-content-center flex-column " style={{ borderRadius: '10px', color: 'white', minHeight: '60px', fontWeight: 'bold' }}>
                  <div className="countdown-wrapper">
                    <div className="countdown-item">
                      {days}
                      <span>days</span>
                    </div>
                    <div className="countdown-item">
                      {remainingHours}
                      <span>hours</span>
                    </div>
                    <div className="countdown-item">
                      {minutes}
                      <span>minutes</span>
                    </div>
                    <div className="countdown-item">
                      {seconds}
                      <span>seconds</span>
                    </div>
                  </div>
                  <div className="px-4 py-2 d-flex align-items-center justify-content-center " style={{ color:'#fff7e5', borderRadius: '10px',  minHeight: '60px', fontWeight: 'bold' }}>
                  The NEFIAI token Staking will begin on May 31st, 2025.
                  </div>
                </div> */}
      </section>

      {/* Stats Section */}
      {/* <section className="container py-5">
        <div className="row text-center">
          <div className="col-md-4 mb-4">
            <div className="card bg-secondary text-white h-100">
              <div className="card-body">
                <h5 className="card-title">Current APY</h5>
                <p className="display-6">18.25%</p>
              </div>
            </div>
          </div>
          <div className="col-md-4 mb-4">
            <div className="card bg-secondary text-white h-100">
              <div className="card-body">
                <h5 className="card-title">Total Staked</h5>
                <p className="display-6">1,253,000 NEFI</p>
              </div>
            </div>
          </div>
          <div className="col-md-4 mb-4">
            <div className="card bg-secondary text-white h-100">
              <div className="card-body">
                <h5 className="card-title">Circulating Supply</h5>
                <p className="display-6">10,000,000 NEFI</p>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* How It Works Section */}
      <section className="bg-black py-5">
        <div className="container text-center">
          <h2 className="mb-4">How Staking Works</h2>
          <div className="row">
            <div className="col-md-4 mb-4">
              <div className="card bg-dark text-white h-100">
                <div className="card-body">
                  <h5 className="card-title">1. Connect Wallet</h5>
                  <p className="card-text">
                    Link your crypto wallet to begin staking NEFI tokens securely.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="card bg-dark text-white h-100">
                <div className="card-body">
                  <h5 className="card-title">2. Stake Tokens</h5>
                  <p className="card-text">
                    Choose the amount to stake and start earning rewards instantly.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="card bg-dark text-white h-100">
                <div className="card-body">
                  <h5 className="card-title">3. Earn Rewards</h5>
                  <p className="card-text">
                    Watch your NEFI balance grow as rewards accumulate in real time.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-dark text-center text-secondary py-3">
        &copy; {new Date().getFullYear()} NEFI AI. All rights reserved.
      </footer>
    </div>
    </Layout>
  );
};

export default Content;
